import React from 'react';

import { ModalDialogRoot } from '@zapier/design-system';

import PartnerProfileForm, {
  PartnerProfileFormValues,
  Role,
} from 'app/developer-v3/components/PartnerProfileForm';

type Props = {
  acceptOnboardingInvite: (invitationData: PartnerProfileFormValues) => void;
  errorMessages: Array<string>;
  isSaving: boolean;
  jobTitle: string;
  roles: Array<Role>;
};

const NewDev = ({
  acceptOnboardingInvite,
  errorMessages,
  isSaving,
  jobTitle,
  roles,
}: Props) => {
  return (
    <ModalDialogRoot
      isOpen
      isDismissable={false}
      aria-label="Welcome to the Zapier Platform"
    >
      <PartnerProfileForm
        errorMessages={errorMessages}
        formTitle="Welcome to the Zapier Platform"
        isHeroImageVisible={true}
        isSaving={isSaving}
        jobTitle={jobTitle}
        onConfirm={acceptOnboardingInvite}
        roles={roles}
        sections={['roles', 'title', 'tos']}
        submitText="Enter Zapier Platform"
      />
    </ModalDialogRoot>
  );
};

export default NewDev;
